import { NestedHome, NestedSearch } from "@habity/types";

export const getRelatedHomesFilters = (home: NestedHome) => {
  const { estimate, address, id } = home || {};
  const { category, living_space, rooms, city, plot_size, area, municipality_id } = address || {};

  const filters: Partial<NestedSearch> = {
    statuses: ["premarket", "for_sale", "offmarket"],
    categories: [category],
    city: city || undefined,
    areaIds: area?.id ? [area.id] : undefined,
    municipalityIds: municipality_id ? [municipality_id] : undefined,
    price_min: estimate ? Math.round(estimate - estimate * 0.15) : null,
    price_max: estimate ? Math.round(estimate + estimate * 0.15) : null,
    rooms_min: rooms && rooms <= 5 ? rooms - 1 : null,
    rooms_max: rooms && rooms <= 5 ? rooms + 1 : null,
    living_space_min: living_space
      ? Math.round(living_space - living_space * 0.2)
      : null,
    living_space_max: living_space
      ? Math.round(living_space + living_space * 0.2)
      : null,
    plot_size_min: plot_size ? Math.round(plot_size - plot_size * 0.5) : null,
    plot_size_max: plot_size ? Math.round(plot_size + plot_size * 0.5) : null,
    // build_year_min: build_year ? build_year - 30 : null,
    // build_year_max: build_year ? build_year + 30 : null,
    // monthly_fee_min: monthly_fee ? monthly_fee - 100 : null,
    // monthly_fee_max: monthly_fee ? monthly_fee + 100 : null,
    ignore_home_ids: [id],
  };
  return filters;
};
